/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const SET_EXTERNALCART_ITEMS = 'MFE/CHECKOUT/EXTERNALCART/SET_EXTERNALCART_ITEMS';
export const GET_EXTERNALCART_ITEMS = 'MFE/CHECKOUT/EXTERNALCART/GET_EXTERNALCART_ITEMS';

export const LOAD_EXTERNALCART_ITEM_ERROR = 'MFE/CHECKOUT/EXTERNALCART/LOAD_ITEM_ERROR';
export const SET_EXTERNALCART_ITEM_ERROR = 'MFE/CHECKOUT/EXTERNALCART/SET_ITEM_ERROR';
export const CLEAR_EXTERNALCART_ITEM_ERROR = 'MFE/CHECKOUT/EXTERNALCART/CLEAR_ITEM_ERROR';

export const SET_EXTERNALCART_ACCESS_TOKEN = 'MFE/CHECKOUT/EXTERNALCART/SET_ACCESS_TOKEN';
export const GET_EXTERNALCART_ACCESS_TOKEN = 'MFE/CHECKOUT/EXTERNALCART/GET_ACCESS_TOKEN';

export const GET_EXTERNALCART_DTW = 'MFE/CHECKOUT/EXTERNALCART/GET_EXTERNALCART_DTW';
export const SET_EXTERNALCART_DTW_BY_ID = 'MFE/CHECKOUT/EXTERNALCART/SET_EXTERNALCART_DTW_BY_ID';

export const EXTERNALCART_ADD_TO_CART = 'MFE/CHECKOUT/EXTERNALCART/ADD_TO_CART';
export const EXTERNALCART_ADD_TO_CART_ERROR = 'MFE/CHECKOUT/EXTERNALCART/ADD_TO_CART_ERROR';
export const EXTERNALCART_ADD_TO_CART_CLEAR_ERROR = 'MFE/CHECKOUT/EXTERNALCART/ADD_TO_CART_CLEAR_ERROR';

export const EXTERNALCART_UPDATE_DTW = 'MFE/CHECKOUT/EXTERNALCART/UPDATE_DTW';
export const EXTERNALCART_UPDATE_DTW_ERROR = 'MFE/CHECKOUT/EXTERNALCART/UPDATE_DTW_ERROR';

export const EXTERNALCART_DELETE_ITEM = 'MFE/CHECKOUT/EXTERNALCART/DELETE_ITEM';
export const EXTERNALCART_DELETE_ITEM_ERROR = 'MFE/CHECKOUT/EXTERNALCART/DELETE_ITEM_ERROR';

export const EXTERNALCART_UPDATE_TIP = 'MFE/CHECKOUT/EXTERNALCART/UPDATE_TIP';
export const EXTERNALCART_UPDATE_TIP_ERROR = 'MFE/CHECKOUT/EXTERNALCART/UPDATE_TIP_ERROR';
